import Seo from "../components/common/Seo";
import PageHeader from "../components/common/PageHeader";
import { Reveal, RevealStagger, RevealItem } from "../components/common/Reveal";
import { Eyebrow, SectionHeading } from "../components/common/Type";
import FinalCTA from "../components/sections/FinalCTA";

const sections = [
  { title: "Why Kratos Exists", text: "Most businesses do not lack tools — they lack a connected operating model. Kratos exists to help companies evolve by combining intelligent technology with practical business execution." },
  { title: "Our Operating Philosophy", text: "Strategy before software. We design how a business should run, then implement the systems and intelligence that make it real — with human oversight at the center." },
  { title: "Strategy + Technology + Execution", text: "We combine three disciplines that are usually separated: commercial strategy, technology architecture, and hands-on execution. The result is systems that actually get used." },
  { title: "Human-Controlled Intelligence", text: "Intelligence with a job to do. Every system we deploy operates under defined permissions, approved scope, and human control." },
  { title: "Long-Term Partnerships", text: "We build systems designed to evolve, and we partner over time to refine and extend them as the business changes." },
  { title: "Future Vision", text: "As intelligent systems and hardware advance, Kratos will continue building the connected operating models — and future intelligent hardware — that help businesses compete at a higher level." },
];

export default function About() {
  return (
    <>
      <Seo
        title="About — Kratos Venture Group"
        description="Our mission: help businesses evolve by combining intelligent technology with practical business execution."
        path="/about"
      />
      <PageHeader
        eyebrow="About"
        title="Help businesses evolve by combining intelligent technology with practical execution."
        intro="That mission shapes everything we design and deploy."
      />

      <section className="relative py-16 md:py-24" data-testid="about-sections">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {sections.map((s, i) => (
              <RevealItem key={s.title} className="kv-card p-8 md:p-9">
                <span className="block h-1 w-8 bg-kv-electric/80" aria-hidden />
                <h2 className="mt-5 font-display text-xl md:text-2xl font-medium tracking-tight text-kv-off">{s.title}</h2>
                <p className="mt-4 font-body text-sm md:text-base text-kv-grey leading-relaxed">{s.text}</p>
              </RevealItem>
            ))}
          </RevealStagger>

          <Reveal>
            <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.16em] text-kv-steel">
              Company details, team, and history will be published as confirmed.
            </p>
          </Reveal>
        </div>
      </section>

      <FinalCTA />
    </>
  );
}
